import { styled, Typography, IconButton } from '@mui/material';

export const CommentW = styled('div')<{ inModal?: boolean }>`
  padding: 16px 20px;
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  color: ${({ theme }) => theme.palette.primary.p040};

  @media (max-width: 1023px) {
    padding: 12px;
    ${({ inModal }) =>
      inModal &&
      `
      border: 0px;
      border-top: 1px solid #ddd;
      border-radius: 0px;
    `}
  }
`;

export const CommentHeaderW = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

export const CommentAuthorInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const UserName = styled('div')`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateTime = styled(Typography)`
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p030};
`;

export const CommentText = styled(Typography)`
  white-space: pre-line;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.main};
  & p {
    margin: 12px 0;

    &:has(code) {
      margin: 4px 0;
    }

    &:first-of-type {
      margin-top: 0;
    }
  }

  & a {
    color: ${({ theme }) => theme.palette.info.main};
  }
`;

export const DeleteButtonW = styled(IconButton)`
  padding: 4px;
  color: ${({ theme }) => theme.palette.primary.p040};
  flex-shrink: 0;
`;

export const OwnerLabel = styled('div')`
  padding: 8px 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.info.light};
  color: ${({ theme }) => theme.palette.primary.main};
`;
